import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../models/auth-state.interface';
import { OtpInitialization } from '../../../interfaces/otp-initialization.interface';

export const AUTH_STATE_NAME = 'auth';

export const authSelector = createFeatureSelector<AuthState>(AUTH_STATE_NAME);

export const loginProcessSelector = createSelector(
  authSelector,
  state => state.loginProcess,
);

export const errorSelector = createSelector(
  authSelector,
  state => state.error,
);

export const userNameSelector = createSelector(
  authSelector,
  state => state.userInfo?.name,
);

export const userRoleSelector = createSelector(
  authSelector,
  state => state.userInfo?.role,
);

export const userIdSelector = createSelector(
  authSelector,
  state => state.userInfo?.id,
)

export const tokenSelector = createSelector(
  authSelector,
  state => state.token,
)

export const updateProfileDataLoading = createSelector(
  authSelector,
  state => state.loadingUpdateProfileData,
)

export const userDataSelector = createSelector(
  authSelector,
  state => ({
    userData: state.userInfo,
    orgInfo: state.orgInfo,
  }),
)

export const sharedOrgsSelector = createSelector(
  authSelector,
  state => ({
    selectedOrg: state.orgInfo?.id,
    shared: state.sharedOrganizations,
  }),
);

export const orgNameSelector = createSelector(
  authSelector,
  state => state.orgInfo?.name,
);

export const orgInfoSelector = createSelector(
  authSelector,
  state => state.orgInfo,
);

export const permissions = createSelector(
  authSelector,
  state => state.permissions,
);

export const has2FAInit = createSelector(
  authSelector,
  state => <OtpInitialization>state.hasInit2FA,
);

export const has2FAVerify = createSelector(
  authSelector,
  state => state.hasVerify2FA,
);

export const disableLoginForm = createSelector(
  authSelector,
  state => Boolean(state.hasInit2FA || state.hasVerify2FA),
);

export const org2FAEnabled = createSelector(
  authSelector,
  state => state.userInfo?.orgEnabledOtp,
);

export const requiredUser2FAInit = createSelector(
  authSelector,
  state => !state.userInfo?.orgEnabledOtp,
);

export const loadingOtpInitData = createSelector(
  authSelector,
  state => state.loadingOtpInitData,
);

export const disabling2FA = createSelector(
  authSelector,
  state => state.disabling2FA,
);

export const isUserAFTRoot = createSelector(
  userRoleSelector,
  role => role === 'aft_root',
);
